import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { clearResponseMessage } from '../../actions/messageActions';
import Loading from '../../components/Loading/Loading';
import ProfileDropDown from '../../components/ProfileDropDown/ProfileDropDown';
import images from '../../assets/images';
import { trackActivity } from '../../services/analyticsService';
import { logout, getUserProfile } from '../../services/authService';
import { getRaceDataNEW } from '../../services/dashboardServiceDB';

class Home extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      hasPurchased: false,
      isLoading: true,
      error: null
    };
  }

  componentDidMount() {
    this._isMounted = true;
    trackActivity('navigation: landing');
    this.loadData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.props.clearResponseMessage();
  }

  loadData = async () => {
    if (!this._isMounted) return;
    this.setState({ isLoading: true, error: null });

    try {
      // Fetch the user's race data the same way the dashboard does, using their
      // preferred language. "Has purchased a current package/race" is defined as
      // the dashboard NOT redirecting away: DashboardV4/Dashboard.js pushes the
      // user to /pricing when raceData[0] is empty.
      const user = await this.props.getUserProfile();
      const language = user?.language || 'en';

      const response = await getRaceDataNEW(language);
      const raceData = response?.data?.data;

      if (!this._isMounted) return;

      this.setState({ hasPurchased: !!raceData?.[0] });
    } catch (error) {
      console.error('Error loading landing data:', error);
      if (this._isMounted) {
        this.setState({ error: 'Unable to load your account right now. Please try again.' });
      }
    } finally {
      if (this._isMounted) {
        this.setState({ isLoading: false });
      }
    }
  };

  onGoToDashboard = () => {
    trackActivity('landing: go to dashboard');
    this.props.history.push('/dashboard');
  };

  onBuyNotes = () => {
    trackActivity('landing: buy notes');
    this.props.history.push('/pricing');
  };

  render() {
    const { user } = this.props.auth;
    const { hasPurchased, isLoading, error } = this.state;

    if (isLoading) return <Loading />;

    return (
      <div className='login-body'>
        <div className='navbar pricing w-nav'>
          <div className='container w-container'>
            <div className='nav-inner-home pricing'>
              <a className='brand-logo-home w-nav-brand'>
                <img src={images['logo'].default} alt='' />
              </a>

              <ProfileDropDown user={user} propsParent={this.props} />

              <div className='menu-button w-nav-button'>
                <div className='icon w-icon-nav-menu'></div>
                <div className='top-line'></div>
                <div className='middle-line'></div>
                <div className='bottom-line'></div>
              </div>
            </div>
          </div>
        </div>

        <div className='pricing-content normal'>
          <div className='container w-container'>
            <div className='pricing-head-block'>
              <h4 className='pricing-title'>Welcome{user && user.displayName ? `, ${user.displayName}` : ''}</h4>
            </div>

            {error && <div className='alert-message'>{error}</div>}

            <div className='pricing-block'>
              <div className='pricing-box-wp'>
                {hasPurchased && (
                  <div className='pricing-box'>
                    <h5 className='plan-text'>My Dashboard</h5>
                    <p className='plan-p'>View the trip notes you’ve purchased.</p>
                    <button type='button' className='btn-square w-button' onClick={this.onGoToDashboard}>
                      Go to Dashboard
                    </button>
                  </div>
                )}

                <div className='pricing-box'>
                  <h5 className='plan-text'>Buy Notes</h5>
                  <p className='plan-p'>Purchase trip notes for a track and race day.</p>
                  <button type='button' className='btn-square w-button' onClick={this.onBuyNotes}>
                    Purchase
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Home.propTypes = {
  auth: PropTypes.object.isRequired,
  getUserProfile: PropTypes.func.isRequired,
  clearResponseMessage: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps, {
  clearResponseMessage,
  getUserProfile,
  logout
})(Home);
